// extracted by mini-css-extract-plugin
export default {"imagePage":"ImagePage_imagePage__FcEsX","sectionOne":"ImagePage_sectionOne__97uQ3"};